import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
import Link from "../../Link/Link/Link.js";
/* empty css                     */
const NotificationBar = ({ title, description, theme = "dark", link = {} }) => {
  const { getLabel } = useIntl();
  const [isHidden, setIsHidden] = React.useState(false);
  const handleClose = React.useCallback(() => setIsHidden(true), []);
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: `notification-bar notification-bar--${theme}` }, /* @__PURE__ */ React.createElement("div", { className: "notification-bar__container" }, title && /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1", className: "notification-bar__title" }, title), description && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "notification-bar__separator" }, "-"), /* @__PURE__ */ React.createElement("p", { className: "notification-bar__description" }, description)), link.url && link.label && /* @__PURE__ */ React.createElement(
    Link,
    {
      className: "notification-bar__link",
      url: link.url,
      label: link.label,
      target: link.target
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "notification-bar__close-icon",
      "aria-label": getLabel("common.actions.close"),
      onClick: handleClose
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "close" })
  )));
};
export {
  NotificationBar as default
};
//# sourceMappingURL=NotificationBar.js.map
